import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import { SharedServices } from '../../services/shared.services'

@Component({
    selector: 'app-test',
    templateUrl: './test.component.html',
    styleUrls: ['./test.component.css'],
})
export class TestComponent implements OnInit {
    @Output() changePage = new EventEmitter()
    @Output() changeButton = new EventEmitter()

    constructor(private _sharedService: SharedServices) {
    }

    ngOnInit() {
        this._sharedService.changeEmitted$.subscribe(
            success => {
                if (success[0] == 'changePageApp') {
                    //
                    if (success[2] === 3) {
                        this.changePage.emit(success[1])
                    } else {
                        this.changePage.emit(success[1])
                        this.changeButton.emit(success[2])
                    }
                }
            })
    }

}



// WEBPACK FOOTER //
// ./src/app/client-app/test/test.component.ts